<template lang="pug">
  div
    b-alert(variant="success" show) {{ successText }}
</template>

<script>

export default {
  name: 'successMsg',
  props: {
    successText: String
  }
}
</script>